"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const luxon_1 = require("luxon");
const actions_1 = require("../../actions");
const reducers_1 = require("../../reducers");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const Row_1 = require("../wizards/components/Row");
const FormSection_1 = require("../utils/FormSection");
const ReportCount_1 = require("./ReportCount");
class ExperienceReport extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    renderNoData() {
        return React.createElement(src_1.Text, { text: "No Data", size: "large", textStyle: { color: src_1.silver } });
    }
    render() {
        const { averageSession, blockClicks, device, postMessage, screenViews, shouldDisplay } = this.props;
        if (!shouldDisplay) {
            return React.createElement("div", null);
        }
        const session = luxon_1.Duration.fromObject({
            seconds: Math.ceil(averageSession),
        }).shiftTo('hours', 'minutes', 'seconds');
        const sessionCopy = `${session.hours > 0 ? `${session.hours} hr ` : ''}${session.minutes > 0 ? `${session.minutes} min ` : ''} ${session.seconds > 0 ? `${session.seconds} sec` : ''}`;
        const blockClickCountBenchmark = Math.max(...blockClicks.map((x) => x.count), 0);
        const screenCountBenchmark = Math.max(...screenViews.map((x) => x.count), 0);
        return (React.createElement(React.Fragment, null,
            React.createElement(FormSection_1.default, { device: device },
                React.createElement(src_1.Text, { size: "h2", text: "Experience" }),
                React.createElement(Row_1.default, null, averageSession === 0 ? (this.renderNoData()) : (React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                    } },
                    React.createElement(src_1.Text, { size: "small", label: true, text: "Average Session" }),
                    React.createElement(src_1.Text, { text: sessionCopy, size: "large" }))))),
            React.createElement(FormSection_1.default, { device: device },
                React.createElement(src_1.Text, { size: "h2", text: "Screen Views" }),
                React.createElement(React.Fragment, null, screenViews.length > 0 ? (screenViews
                    .sort((a, b) => b.count - a.count)
                    .map(({ count, ID, name }) => (React.createElement(ReportCount_1.default, { key: ID, benchmark: screenCountBenchmark, clickHandler: () => postMessage({ setScreen: ID }), count: count, device: device, label: name, linkId: ID })))) : (React.createElement(Row_1.default, null, this.renderNoData())))),
            React.createElement(FormSection_1.default, { device: device },
                React.createElement(src_1.Text, { size: "h2", text: "Block Taps" }),
                React.createElement(React.Fragment, null, blockClicks.length > 0 ? (blockClicks
                    .sort((a, b) => b.count - a.count)
                    .map(({ count, ID, name, screenID }, index) => (React.createElement(ReportCount_1.default, { key: index, benchmark: blockClickCountBenchmark, clickHandler: () => postMessage({
                        highlightId: ID,
                        highlightStyle: {
                            outline: `4px solid ${src_1.turquoise}`,
                            outlineOffset: `-4px`,
                        },
                        setScreen: screenID,
                    }), count: count, device: device, label: name, linkId: ID })))) : (React.createElement(Row_1.default, null, this.renderNoData()))))));
    }
}
exports.ExperienceReport = ExperienceReport;
const mapStateToProps = (state, ownProps) => {
    const tapBehavior = reducers_1.getCampaignTapBehavior(state, ownProps.campaignId);
    return {
        averageSession: reducers_1.getAverageSession(state),
        blockClicks: reducers_1.getBlockClicks(state),
        screenViews: reducers_1.getScreenViews(state),
        shouldDisplay: tapBehavior.type === 'PRESENT_EXPERIENCE' && tapBehavior.experienceID !== '',
    };
};
const mapDispatchToProps = (dispatch) => ({
    fetchCampaignReport: (campaignId) => dispatch(actions_1.fetchCampaignReport(campaignId)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExperienceReport);
